export default __webpack_public_path__ + "assets/86ebab1671c4e179af3a8a8df69b1bc0.png";